// src/components/Footer.js
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FileX } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer
      className="main-footer"
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <div className=" d-none d-sm-block">
        Copyright &copy; {currentYear}. All rights reserved.
      </div>
      <div>
        Powered By
        <a href="http://www.mindzcube.com">
          <img
            src="/img/mindzcube.png"
            height="30px"
            alt="Mindzcube"
            style={{ marginLeft: "15px" }}
          />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
